angular.module('app-ui-profile').directive(
    'appUiProfileUserProfileSearchResultsModal',
    function () {

        var link = function ($scope) {

            $scope.handleClose = function () {
                $scope.propOnClose();
            };
        };

        return {
            link: link,
            scope: {
                propSearchId: '=searchId', // Search unique id
                propLoading: '=loading', // bool
                propResults: '=results',
                propOnResultSelect: '=onResultSelect', // function(result)
                propSearchProperties: '=searchProperties', // [{name: '', label: ''}]
                propDisplay: '=display', // {bool}
                propOnClose: '=onClose',
                propModalTitle: '=modalTitle',
                propModalBody: '=modalBody',
            },
            template: '' +
            '<div ng-if="propDisplay" class="app-ui-search-results-modal">' +
            '   <div class="modal" ng-class="{show:propDisplay}">' +
            '       <div class="modal-dialog" role="document">' +
            '          <div class="modal-content">' +
            '              <div class="modal-header">' +
            '                   <button type="button"' +
            '                           class="close"' +
            '                           ng-click="handleClose()"' +
            '                           aria-label="Close">' +
            '                       <span aria-hidden="true">&times;</span>' +
            '                   </button>' +
            '                   <h4 class="modal-title">{{propModalTitle | translate}}</h4>' +
            '               </div>' +
            '               <div class="modal-body">' +
            '                   <div class="text-muted">{{propModalBody | translate}}</div>' +
            '               <app-ui-profile-user-profile-search-results' +
            '                   search-id="propSearchId"' +
            '                   loading="propLoading"' +
            '                   results="propResults"' +
            '                   on-result-select="propOnResultSelect"' +
            '                   search-properties="propSearchProperties"' +
            '                   >' +
            '               </app-ui-profile-user-profile-search-results>' +
            '               </div>' +
            '               <div class="modal-footer">' +
            '                   <button type="button"' +
            '                           class="btn btn-default"' +
            '                           ng-click="handleClose()">' +
            '                       Close' +
            '                   </button>' +
            '               </div>' +
            '           </div><!-- /.modal-content -->' +
            '       </div><!-- /.modal-dialog -->' +
            '   </div><!-- /.modal -->' +
            '</div>',
        };
    }
);
